import './loading-animation.scss';

const LoadingAnimation = (props) => {
	const { type } = props;

	if ('inline' === type) {
		return (
			<div className="loading-animation loading-animation--inline">
				<div className="loading-animation__card">
					<ul className="loading-animation__article">
						<li></li>
					</ul>
				</div>
			</div>
		);
	}

	if ('grid' === type) {
		return (
			<div className="loading-animation loading-animation__grid">
				<div className="loading-animation__card">
					<div className="loading-animation__image"></div>
					<ul className="loading-animation__article">
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
					</ul>
				</div>
				<div className="loading-animation__card">
					<div className="loading-animation__image"></div>
					<ul className="loading-animation__article">
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
					</ul>
				</div>
				<div className="loading-animation__card">
					<div className="loading-animation__image"></div>
					<ul className="loading-animation__article">
						<li></li>
						<li></li>
						<li></li>
						<li></li>
						<li></li>
					</ul>
				</div>
			</div>
		);
	}

	if ('filters' === type) {
		return (
			<ul className="loading-animation loading-animation__filters">
				<li></li>
				<li></li>
				<li></li>
				<li></li>
				<li></li>
			</ul>
		);
	}

	return (
		<div className="loading-animation">
			<div className="loading-animation__card">
				<div className="loading-animation__image"></div>
				<ul className="loading-animation__article">
					<li></li>
					<li></li>
					<li></li>
					<li></li>
					<li></li>
				</ul>
			</div>
		</div>
	);
};

export default LoadingAnimation;
